import React, { Component } from 'react'
import Prompt from './Prompt'

export default class S extends Component {
  render() {
    return <Prompt color="orange" letter="S" {...this.props} />
  }
}



// WEBPACK FOOTER //
// ./src/components/Prompts/S.js